import apiClient from '../../../services/apiClient';
import { unwrapData, unwrapList } from './settingsResponse';

export const schoolSettingsApi = {
  listSchools: async () => {
    const response = await apiClient.get('/schools/');
    return unwrapList(response.data);
  },

  getProfile: async (schoolId) => {
    const response = await apiClient.get(`/schools/${schoolId}/profile/`);
    return unwrapData(response.data);
  },

  updateProfile: async (schoolId, payload) => {
    const response = await apiClient.patch(
      `/schools/${schoolId}/profile/update/`,
      payload,
    );
    return unwrapData(response.data);
  },

  getBranding: async (schoolId) => {
    const response = await apiClient.get(`/schools/${schoolId}/branding/`);
    return unwrapData(response.data);
  },

  updateBranding: async (schoolId, formData) => {
    const response = await apiClient.patch(
      `/schools/${schoolId}/branding/update/`,
      formData,
    );
    return unwrapData(response.data);
  },
};
